import {ContactDataModel} from '../../../models/person/contact-data.model';

export class PatientSubscriberContactListModel extends ContactDataModel{
  PhoneHome: string = '';
  PhoneMobile: string = '';
  dataContact: ContactDataModel;
  PatientRelationshipName: string;
}
